import React, { useEffect, useState } from 'react';
import { Select, Spin, message } from 'antd';
import debounce from 'lodash/debounce';
import {
  apiGetDevicesInformation,
  apiGetDevicesInformationV2
} from '@services/ManageDevices/DeviceServices';

const { Option } = Select;

const DeviceSelectV2 = ({
  onChange,
  initValue,
  disabled,
  placeholder = 'Lựa chọn thiết bị',
  type
}) => {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [deviceSelected, setDeviceSelected] = useState(null);

  const fetchDevices = async (searchText, type) => {
    setLoading(true);
    try {
      const response = await apiGetDevicesInformationV2({
        keyWord: searchText ?? undefined,
        status: type == 'NEW' ? 'STORED' : undefined,
        page: 1,
        size: 200
      });
      setDevices(
        response?.data?.data?.map((item) => ({
          label: `IMEI:${item?.imei?.toString()} S/N:${item?.serial_no?.toString()}`,
          value: item?.serial_no?.toString(),
          ...item
        }))
      );
    } catch (error) {
      message.error('Có lỗi khi lấy thông tin thiết bị!');
      console.error('Failed to fetch devices', error);
    }
    setLoading(false);
  };

  const handleSearch = debounce((value) => {
    fetchDevices(value);
  }, 300);

  const handleChange = (value, option) => {
    setDeviceSelected(value);
    onChange && onChange(option);
  };

  useEffect(() => {
    fetchDevices(null, type);
  }, [type]);

  useEffect(() => {
    if (initValue && devices.length > 0) {
      const deviceFound = devices.find((device) => device.serial_no === initValue);
      if (deviceFound) {
        setDeviceSelected({
          value: deviceFound.serial_no,
          label: `${deviceFound.serial_no} - ${deviceFound.imei}`
        });
      }
    }
  }, [initValue, devices]);

  return (
    <Select
      disabled={disabled}
      showSearch
      labelInValue
      placeholder={placeholder}
      onChange={handleChange}
      value={deviceSelected}
      notFoundContent={loading ? <Spin size="small" /> : null}
      filterOption={false}
      onSearch={handleSearch}
      style={{ width: '100%', height: '36px' }}
      options={devices}
      optionLabelProp="label"
    />
  );
};

export default DeviceSelectV2;
